import { render, staticRenderFns } from "./default-min-score.vue?vue&type=template&id=9256b438&"
import script from "./default-min-score.ts?vue&type=script&lang=ts&"
export * from "./default-min-score.ts?vue&type=script&lang=ts&"
import style0 from "./default-min-score.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports